// extracted by mini-css-extract-plugin
module.exports = {"logo":"white__logo--1pBLJ"};
    if(module.hot) {
      // 1545480330941
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  